module.exports = __webpack_public_path__ + "img/goods_type-true.5d2c7a53.png";